// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3c6wa","questions":"styles_questions__1lO2e","footer":"styles_footer__2j9EO"};